var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 6.33 6.33"}},[_c('path',{attrs:{"d":"M553.83,397.42l-5.9,5.9m.9-5.82,5-.08-.08,5","transform":"translate(-547.76 -397.17)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }